import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA, MatDialogActions, MatDialogContent,
  MatDialogRef, MatDialogTitle
} from '@angular/material/dialog';
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatButton } from "@angular/material/button";
import { MatInput } from "@angular/material/input";
import { CredentialTypes } from "@fry/lib/auth/account/credential/credential";



@Component({
    selector: 'app-edit-username-credential-dialog',
    templateUrl: './update-credential-username-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatDialogActions,
    MatDialogTitle,
    MatButton,
    MatInput,
    ReactiveFormsModule,
    MatLabel
]
})
export class UpdateCredentialUsernameDialogComponent implements OnInit {
  editUsernameForm: FormGroup = new FormGroup({});
  currentCredentialUsername: string = '';
  dialogTitle: string = '';
  label: string = '';
  organisationId: string = '';

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UpdateCredentialUsernameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      organisationId: string,
      currentCredentialUsername: string,
      credentialType: CredentialTypes
    }
  ) {
    this.organisationId = data.organisationId;
    this.currentCredentialUsername = data.currentCredentialUsername;
    if (data.credentialType === CredentialTypes.LOCAL) {
      this.dialogTitle = 'Edit local credential\'s username';
      this.label = 'New Local Username';
    } else if (data.credentialType === CredentialTypes.PROXY) {
      this.dialogTitle = 'Edit SSO credential\'s ID';
      this.label = 'New SSO ID';
    }
  }

  ngOnInit(): void {
    this.editUsernameForm = this.fb.group({
      newUsername: [this.currentCredentialUsername, Validators.required]
    });
  }

  onSubmit() {
    if (this.editUsernameForm.valid) {
      this.dialogRef.close(this.editUsernameForm.value);
    }
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}
